import { Component, Input, OnInit } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { SelectOption, TemplateSelectComponent } from "../../templates/template-select/template-select.component";

@Component({
  standalone: true,
  selector: "app-prefix-idl",
  imports: [TemplateSelectComponent],
  templateUrl: "./prefix-idl.component.html",
  styleUrl: "./prefix-idl.component.less",
})
export class PrefixIdlComponent extends PrefixComponent<string> implements OnInit {
  @Input()
  public options: SelectOption[];
  public multiple: boolean;
  public disabled: boolean;

  public constructor() {
    super();
    this.options = [];
    this.multiple = false;
    this.disabled = false;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["idl"];
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    this.options.unshift({ label: "-", value: "-" });
  }

  protected override setInitialControlValue(value: string | null): void {
    super.setInitialControlValue(value);
    if (value) this.disabled = true;
  }
}
